import request from '@helpers/request';
import { API_E_RECOGNITION_PATH, API_HOST_NAME } from '../env';

export const getERecognitionTerritoriesService = ({ saleChannel, type }) =>
  request(
    `${API_HOST_NAME}${API_E_RECOGNITION_PATH}/get-territories?saleChannel=${saleChannel}&type=${type}`,
    {
      method: 'GET',
    },
  );

export const getERecognitionListService = ({
  saleChannel,
  distributionTeam,
  advisorCode,
  advisorName,
  achievementYear,
  achievementCodes,
  page,
  size,
}) =>
  request(
    `${API_HOST_NAME}${API_E_RECOGNITION_PATH}/search-achievements?page=${page}&size=${size}`,
    {
      method: 'POST',
      data: {
        saleChannel,
        distributionTeam,
        advisorCode,
        advisorName,
        achievementYear,
        achievementCodes,
      },
    },
  );

export const getERecognitionAgentAvatarService = ({ advisorCode }) =>
  request(
    `${API_HOST_NAME}${API_E_RECOGNITION_PATH}/get-agent-avatar?agentCode=${advisorCode}`,
    {
      method: 'GET',
      responseType: 'blob',
    },
  );

export const downloadERecognitionService = ({ agentCode }) =>
  request(`${API_HOST_NAME}${API_E_RECOGNITION_PATH}/download-details-file`, {
    method: 'POST',
    data: {
      agentCode,
    },
  });
